module.exports = __webpack_public_path__ + "static/warehouse-exp-img-3-4c6c2f14243217423a68c6d03ede14fd.png";